import { JsonProperty, ObjectMapper } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';
import { RecruitCompanyBenefitItemModel } from './recruit-company-benefit-item.model';

export class RecruitCompanyBenefitsConfigModel
extends Model
implements IModel<RecruitCompanyBenefitsConfigModel>
{
  @JsonProperty()
  public companyGroupId: string | null = null;

  @JsonProperty({ type: RecruitCompanyBenefitItemModel })
  public benefits: RecruitCompanyBenefitItemModel[] = [];

  static create(input: any): RecruitCompanyBenefitsConfigModel {
    const recruitCompanyBenefitsConfig = ObjectMapper.deserialize<RecruitCompanyBenefitsConfigModel>(RecruitCompanyBenefitsConfigModel, input);
    recruitCompanyBenefitsConfig.benefits = input.benefits.map(RecruitCompanyBenefitItemModel.create);
    return recruitCompanyBenefitsConfig;
  }
}
